/**
 * Gallerian lightbox (core/gallery, kuvat linkitetty mediatiedostoon).
 *
 * Ladataan vain sivuilla, joilla on galleria (hopia_enqueue_gallery_script).
 * Käyttää natiivia <dialog>-elementtiä: Esc sulkee ja fokus pysyy ikkunassa.
 */
(function () {
  'use strict';

  var kuvaLinkki = /\.(avif|gif|jpe?g|png|webp)(\?.*)?$/i;

  document.querySelectorAll('.wp-block-gallery').forEach(function (galleria) {
    var linkit = Array.prototype.filter.call(galleria.querySelectorAll('a[href]'), function (a) {
      return kuvaLinkki.test(a.getAttribute('href'));
    });
    if (!linkit.length) return;

    var nykyinen = 0;
    var dialogi = document.createElement('dialog');
    dialogi.className = 'galleria-lightbox';
    dialogi.setAttribute('aria-label', 'Kuvagalleria');
    dialogi.innerHTML =
      '<figure><img alt=""><figcaption></figcaption></figure>' +
      '<p class="galleria-laskuri"></p>' +
      '<button type="button" class="galleria-sulje" aria-label="Sulje">&times;</button>' +
      (linkit.length > 1
        ? '<button type="button" class="galleria-edellinen" aria-label="Edellinen kuva">&#8249;</button>' +
          '<button type="button" class="galleria-seuraava" aria-label="Seuraava kuva">&#8250;</button>'
        : '');
    document.body.appendChild(dialogi);

    var kuva = dialogi.querySelector('img');
    var kuvateksti = dialogi.querySelector('figcaption');
    var laskuri = dialogi.querySelector('.galleria-laskuri');

    function nayta(i) {
      nykyinen = (i + linkit.length) % linkit.length;
      var linkki = linkit[nykyinen];
      var pikkukuva = linkki.querySelector('img');
      var figure = linkki.closest('figure');
      var caption = figure ? figure.querySelector('figcaption') : null;
      kuva.src = linkki.getAttribute('href');
      kuva.alt = pikkukuva ? pikkukuva.alt : '';
      kuvateksti.textContent = caption ? caption.textContent : '';
      laskuri.textContent = linkit.length > 1 ? (nykyinen + 1) + ' / ' + linkit.length : '';
    }

    linkit.forEach(function (linkki, i) {
      linkki.addEventListener('click', function (e) {
        e.preventDefault();
        nayta(i);
        dialogi.showModal();
      });
    });

    dialogi.querySelector('.galleria-sulje').addEventListener('click', function () {
      dialogi.close();
    });

    if (linkit.length > 1) {
      dialogi.querySelector('.galleria-edellinen').addEventListener('click', function () {
        nayta(nykyinen - 1);
      });
      dialogi.querySelector('.galleria-seuraava').addEventListener('click', function () {
        nayta(nykyinen + 1);
      });
      dialogi.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') nayta(nykyinen - 1);
        if (e.key === 'ArrowRight') nayta(nykyinen + 1);
      });
    }

    // Klikkaus kuvan ulkopuolelle sulkee
    dialogi.addEventListener('click', function (e) {
      if (e.target === dialogi || e.target.tagName === 'FIGURE') dialogi.close();
    });
  });
})();
